import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ClinicService from '../../../services/clinic.service';
import './SmsConfirmation.css'; // We'll create this CSS file

function SmsConfirmation() {
  let { clinicId, messageId } = useParams();
  const [clinic, setClinic] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    ClinicService.getGatewayClinicInfo(clinicId, messageId)
      .then((res) => {
        setClinic(res.data);
        setLoading(false);
        setError(null);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setError('Failed to load clinic information. Please try again later.');
      });
  }, [clinicId, messageId]);

  return (
    <div className="sms-confirmation-page min-vh-100 bg-light">
      {/* Loading State */}
      {loading && (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
          <div className="text-center">
            <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted">Loading confirmation...</p>
          </div>
        </div>
      )}

      {/* Error State */}
      {error && !loading && (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
          <div className="alert alert-danger text-center mx-3" role="alert">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
          </div>
        </div>
      )}

      {/* Success State */}
      {!loading && !error && clinic && (
        <>
          {/* Header */}
          <header className="bg-white shadow-sm py-3">
            <div className="container">
              <div className="d-flex justify-content-center align-items-center">
                {clinic?.logo ? (
                  <img 
                    src={clinic.logo} 
                    alt={`${clinic.name} logo`} 
                    className="clinic-logo img-fluid"
                    style={{ maxHeight: '80px' }}
                  />
                ) : (
                  <h1 className="clinic-name h4 mb-0 text-primary">{clinic.name}</h1>
                )}
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main className="container py-5">
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6">
                {/* Success Card */}
                <div className="card shadow border-0 mb-4">
                  <div className="card-body text-center p-4 p-md-5">
                    <div className="success-icon mb-3">
                      <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '3rem' }}></i>
                    </div>
                    <h2 className="card-title h4 mb-3">Confirmation Received</h2>
                    <p className="text-success fw-semibold mb-0">{clinic.confirmationMessage}</p>
                  </div>
                </div>

                {/* Clinic Info Card */}
                <div className="card shadow border-0">
                  <div className="card-body p-4 p-md-5">
                    <h3 className="h5 mb-4 text-center">Thank you for your interest in {clinic.name}</h3>
                    
                    <div className="clinic-details">
                      <div className="detail-item mb-3">
                        <i className="bi bi-telephone-fill me-2 text-primary"></i>
                        <span>Phone: <a href={`tel:${clinic.phone}`} className="text-decoration-none">{clinic.phone}</a></span>
                      </div>
                      
                      <div className="detail-item mb-3">
                        <i className="bi bi-envelope-fill me-2 text-primary"></i>
                        <span>Email: <a href={`mailto:${clinic.email}`} className="text-decoration-none">{clinic.email}</a></span>
                      </div>
                      
                      <div className="detail-item mb-3">
                        <i className="bi bi-globe me-2 text-primary"></i>
                        <span>Website: <a href={`https://${clinic.website}`} target="_blank" rel="noopener noreferrer" className="text-decoration-none">{clinic.website}</a></span>
                      </div>
                      
                      <div className="detail-item mb-3">
                        <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
                        <span>Address: {clinic.street}, {clinic.city}, {clinic.postalCode}, {clinic.country}</span>
                      </div>
                      
                      {clinic.sms && (
                        <div className="detail-item">
                          <i className="bi bi-chat-dots-fill me-2 text-primary"></i>
                          <span>SMS: {clinic.sms}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>

          {/* Footer */}
          <footer className="bg-white mt-5 py-4 border-top">
            <div className="container text-center text-muted small">
              <p className="mb-0">© {new Date().getFullYear()} {clinic.name}. All rights reserved.</p>
            </div>
          </footer>
        </>
      )}
    </div>
  );
}

export default SmsConfirmation;